import type { FlightCalendar } from 'common/packageCache';
import React from 'react';
import { FormattedCurrency } from 'i18n';

function renderPriceCell(text: string, record: FlightCalendar): React.ReactNode {
  return <FormattedCurrency value={record.price} currency={record.currency} />;
}

export default renderPriceCell;
